import React from "react";

import { Row } from "@rui/Stack";

import { AnnotationIndicator, AnnotationLabel } from "./styles";

interface TranscriptTurnAnnotationsProps {
  annotations: { direction: "positive" | "negative"; label: string }[];
}

const TranscriptTurnAnnotations = ({
  annotations,
}: TranscriptTurnAnnotationsProps) => {
  return (
    <Row
      variant="right"
      className="transcript-turn__annotations"
      width="100%"
      spacing={2}
      paddingRight={2}
    >
      {annotations.map(({ direction, label }) => (
        <Row key={label} variant="right" spacing={1}>
          <AnnotationIndicator type={direction} />
          <AnnotationLabel>{label}</AnnotationLabel>
        </Row>
      ))}
    </Row>
  );
};

export default TranscriptTurnAnnotations;
